import { render, staticRenderFns } from "./ReceiptSerial.vue?vue&type=template&id=dfee2a58&"
import script from "./ReceiptSerial.vue?vue&type=script&lang=js&"
export * from "./ReceiptSerial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports